import { render, staticRenderFns } from "./EditAccount.vue?vue&type=template&id=d6436684&scoped=true"
import script from "./EditAccount.vue?vue&type=script&lang=js"
export * from "./EditAccount.vue?vue&type=script&lang=js"
import style0 from "./EditAccount.vue?vue&type=style&index=0&id=d6436684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6436684",
  null
  
)

export default component.exports